import { VymirConfig } from '../../vymirConfiguratorMap';
import { VymirTheme, buildVymirTokens } from './vymirThemeTokens';

export function buildEmbedUrl(config: VymirConfig, theme: VymirTheme): string {
  const tokens = buildVymirTokens(theme);
  const tokenString = Object.entries(tokens)
    .map(([key, value]) => `${key}:${value}`)
    .join(';');
  const params = new URLSearchParams({ theme, tokens: tokenString });
  return `${config.origin}/embed/${config.tenant}/${
    config.slug
  }?${params.toString()}`;
}

export function getTargetOrigin(config: VymirConfig): string {
  return config.origin;
}
